<span errorHandling [shouldDisplayErrorInDialog]="false"></span>
<router-outlet></router-outlet>
